var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClientUpdate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 77,
    viewBox: "0 0 76 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 77,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Client details have been updated successfully",
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -258,
    y: -57,
    width: 592,
    height: 371,
    rx: 14,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 48471"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 48373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 48360"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 48472"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M65.0726 13.2275C65.0726 12.1443 65.0726 11.161 65.0726 10.1746C65.0726 7.86637 65.0629 5.55817 65.0822 3.25319C65.1016 1.14163 67.11 -0.418661 69.1087 0.100362C70.4659 0.45175 71.4749 1.77993 71.4782 3.25641C71.4846 6.377 71.4782 9.49758 71.4782 12.6214C71.4782 15.9967 71.4749 19.3719 71.4717 22.7472C71.4717 24.6105 70.0952 26.0354 68.2415 26.0386C61.7328 26.0451 55.224 26.0419 48.7121 26.029C46.8423 26.0257 45.44 24.5718 45.4432 22.702C45.4464 21.0289 46.9293 19.633 48.7411 19.6298C53.048 19.6234 57.3581 19.6298 61.6651 19.633C61.823 19.633 61.981 19.633 62.2067 19.633C62.1132 19.5009 62.0551 19.4042 61.9842 19.3236C57.1325 13.7175 51.0718 10.1649 43.783 8.83349C35.6591 7.35057 28.0962 8.89797 21.1522 13.3758C15.6429 16.9251 11.7163 21.8026 9.26307 27.8504C7.32882 32.6151 6.60348 37.5925 7.19342 42.7086C8.21858 51.6029 12.2869 58.8403 19.376 64.3077C23.6926 67.6379 28.6249 69.6527 34.0279 70.3522C42.0744 71.3935 49.489 69.5914 56.1299 64.917C62.7611 60.249 66.8908 53.8692 68.6638 45.9646C68.8411 45.1716 68.9636 44.3689 69.1087 43.5694C69.4021 41.9704 70.9495 40.8388 72.5613 41.0484C74.5472 41.3063 75.6852 43.0084 75.3434 45.0072C74.9179 47.4701 74.3924 49.8976 73.5123 52.238C69.6793 62.438 62.7676 69.7172 52.7708 74.0596C49.5954 75.4393 46.2781 76.313 42.8481 76.7127C32.7158 77.8861 23.4991 75.4748 15.3914 69.2981C8.04772 63.6984 3.3894 56.2967 1.44226 47.238C0.616981 43.3856 0.368753 39.5074 0.816854 35.6067C1.72273 27.7408 4.65634 20.7356 9.89492 14.7555C14.3469 9.67167 19.7854 6.02883 26.1942 3.87537C30.8589 2.3054 35.6559 1.66388 40.5721 2.00882C48.1221 2.54074 54.9403 5.06493 60.972 9.64265C62.2744 10.6323 63.451 11.7864 64.6857 12.8632C64.7953 12.9567 64.8953 13.0598 65.0726 13.2275Z",
    fill: "#2BC3F2"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: -282,
    y: -73,
    width: 640,
    height: 419,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientUpdate);
export default __webpack_public_path__ + "static/media/ClientUpdate.e3ad148aa7027c01e5086af43bbe739c.svg";
export { ForwardRef as ReactComponent };